var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-shimmer"},_vm._l((_vm.qty),function(container){return _c('div',{key:container,staticClass:"shimmer-content",style:({'height': _vm.isHeight ? _vm.isHeight : '5rem'})},[_c('div',{staticClass:"shimmer"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }